export const useTheme = () => "light";

document.documentElement.classList.add("theme-light");
